import { render, staticRenderFns } from "./entity-document-folder-create.vue?vue&type=template&id=693180c7&scoped=true"
import script from "./entity-document-folder-create.vue?vue&type=script&lang=js"
export * from "./entity-document-folder-create.vue?vue&type=script&lang=js"
import style0 from "./entity-document-folder-create.vue?vue&type=style&index=0&id=693180c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693180c7",
  null
  
)

export default component.exports